module.exports = __webpack_public_path__ + "static/media/Anfahrt2.79af3e4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Anfahrt2.jpg
// module id = 327
// module chunks = 0